import { createAllBlock, switchLoading, getErreurBlock } from './block';
import Macy from 'macy';

fetch(`/controller/prodeval/murSocial`)
.then(res => res.json())
.then(jsonData => {

    // Traitement des erreurs
    if(jsonData.error || jsonData.length === 0) {
        onError();
        return false;
    }

    let totalPostPage = 12; // Nombre de poste afficher sur la page

    // Transforme les données récupéré en element JQuery
    let blocks = createAllBlock(jsonData);
    let firstBlocks = blocks.slice(0, totalPostPage);

    $('.flexmasonry').append(firstBlocks);
    let grid = initFlexmasonry();

    let totalNewPost = 8;
    /**
     * Evenement lors du clique sur le bouton pour afficher plus d'element
     */
    $('#showMore').on('click', function(event){
        event.preventDefault();

        // récupère les prochains block à être ajouté sur la page
        let nextBlocks = blocks.slice(totalPostPage, totalPostPage + totalNewPost);
        totalPostPage += totalNewPost

        // S'il n'y a plus de block à afficher, supprimer le bouton "Voir plus"
        if(nextBlocks.length === 0){
            removeShowMoreButton();
            return;
        }
        
        $('.flexmasonry').append(nextBlocks);
        grid.recalculate();

        // Si tous les blocks existant sont déjà afficher, supprimer le bouton "Voir plus"
        if(totalPostPage >= blocks.length) {
            removeShowMoreButton();
        }
    });

    return true;
})
.catch(result => {
    onError();
})
.then(result => {
    switchLoading();
    // Affiche le bouton "Charger plus"
    $('#showMore').removeClass('d-none');
})

/**
 * @see https://github.com/bigbite/macy.js
 * @return {flexmasonry}
 */
function initFlexmasonry()
{
    return Macy({
        container: '.flexmasonry',
        columns: 3,
        trueOrder: false,
        margin: 0,
        waitForImages: false,
        useOwnImageLoader: false,
        mobileFirst: false,
        breakAt: {
            1500: 4,
            1200: 4,
            992: 3,
            768: 2,
            576: 1,
        },
        cancelLegacy: false,
        useContainerForBreakpoints: true
    });
}

/**
 * @return {void}
 */
function removeShowMoreButton()
{
   $('#showMore').remove();
}

/**
 * Appeller lors d'une erreur sur la page
 * @return {void}
 */
function onError()
{
    $('.flexmasonry').append(getErreurBlock($('.flexmasonry').data('erreur-message')));
    removeShowMoreButton();
}